import React from 'react';
import { Mail, MapPin, MessageCircle, Building2, Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, currentLang } = useLanguage();
  const currentYear = new Date().getFullYear();

  const offices = [
    { city: currentLang === 'ru' ? 'Сингапур' : currentLang === 'ar' ? 'سنغافورة' : 'Singapore', address: '150 S Bridge Rd, #06-04A, Fook Hai Building, Singapore 058727' },
    { city: currentLang === 'ru' ? 'Дубай' : currentLang === 'ar' ? 'دبي' : 'Dubai', address: 'The Offices 2, One Central – Trade Center Second, Dubai' },
    { city: currentLang === 'ru' ? 'Лондон' : currentLang === 'ar' ? 'لندن' : 'London', address: '47-49 Park Royal Rd, London, NW10 7LQ, UK' },
    { city: currentLang === 'ru' ? 'Нью-Йорк' : currentLang === 'ar' ? 'نيويورك' : 'New York', address: '9 West 57th St, New York, NY 10019, USA' },
    { city: currentLang === 'ru' ? 'Сан-Франциско' : currentLang === 'ar' ? 'سان فرانسيسكو' : 'San Francisco', address: '50 Fremont St, San Francisco, CA 94105, USA' },
    { city: currentLang === 'ru' ? 'Нью-Дели' : currentLang === 'ar' ? 'نيودلهي' : 'New Delhi', address: '402, Statesman House, Barakhamba, New Delhi – 110001, India' }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-column footer-brand-col">
            <div className="footer-brand">
              <h3 className="footer-logo">CAPITARA</h3>
              <div className="footer-tagline">Global Financial Justice</div>
            </div>
            <p className="footer-description">{t.footerDesc}</p>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">{t.services}</h4>
            <ul className="footer-links">
              <li><a href="#services" className="footer-link">{t.brokerRecovery}</a></li>
              <li><a href="#services" className="footer-link">{t.cryptoFraud}</a></li>
              <li><a href="#services" className="footer-link">{t.investmentDisputes}</a></li>
              <li><a href="#services" className="footer-link">{t.pyramidRecovery}</a></li>
              <li><a href="#calculator" className="footer-link">{t.returnCalculator}</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">{t.company}</h4>
            <ul className="footer-links">
              <li><a href="#about" className="footer-link">{t.about}</a></li>
              <li><a href="#process" className="footer-link">{t.howWeWork}</a></li>
              <li><a href="#testimonials" className="footer-link">{t.testimonials}</a></li>
              <li><a href="#offices" className="footer-link">{t.ourOffices}</a></li>
              <li><a href="#faq" className="footer-link">{t.faq}</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">{t.contacts}</h4>
            <ul className="footer-contacts">
              <li className="footer-contact">
                <Mail size={18} />
                <span>CapitaraFinancial@gmail.com</span>
              </li>
              <li className="footer-contact">
                <MessageCircle size={18} />
                <span>Telegram @Capitara</span>
              </li>
              <li className="footer-contact">
                <Globe size={18} />
                <span>{t.internationalWork}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-offices">
          <h4 className="footer-offices-title">
            <Building2 size={20} />
            {t.ourOffices}
          </h4>
          <div className="footer-offices-grid">
            {offices.map((office, index) => (
              <div key={index} className="footer-office-item">
                <div className="footer-office-city">
                  <MapPin size={14} />
                  {office.city}
                </div>
                <div className="footer-office-address">{office.address}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            © 2013-{currentYear} Capitara. {t.allRightsReserved}
          </div>
          <div className="footer-legal">
            <a href="#" className="footer-legal-link">{t.privacyPolicy}</a>
            <a href="#" className="footer-legal-link">{t.termsOfUse}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
